import './projectCard.css';

const ProjectCard = ({ image, link, title }) => {
	return (
		<div className='project'>
			<div className='project-bar'>
				<div className='project-bar-circle'></div>
				<div className='project-bar-circle'></div>
				<div className='project-bar-circle'></div>
			</div>
			<a
				href={link}
				target='_blank'
				rel='noreferrer'
			>
				<img
					src={image}
					alt={title}
					className='project-img'
				/>
			</a>
		</div>
	);
};

export default ProjectCard;
